import api from './api';

/**
 * Empresas (tenants).
 *
 * Quem não tem GERENCIAR_EMPRESAS só enxerga a própria empresa — o recorte é
 * feito no backend, a tela apenas apresenta o que voltar.
 */
class EmpresaService {
  /** Empresa do usuário logado (não exige permissão). */
  async buscarAtual() {
    const response = await api.get('/empresas/atual');
    return response.data;
  }

  /** Listar empresas. Retorna { records, total }. */
  async listar(filtros = {}) {
    const params = new URLSearchParams();

    if (filtros.nome) params.append('nome', filtros.nome);
    if (filtros.ativo === 'true' || filtros.ativo === 'false') {
      params.append('ativo', filtros.ativo);
    }

    const query = params.toString();
    const response = await api.get(`/empresas${query ? `?${query}` : ''}`);
    return response.data;
  }

  async buscarPorId(id) {
    const response = await api.get(`/empresas/${id}`);
    return response.data;
  }

  async criar(dados) {
    const response = await api.post('/empresas', dados);
    return response.data;
  }

  async atualizar(id, dados) {
    const response = await api.put(`/empresas/${id}`, dados);
    return response.data;
  }

  async excluir(id) {
    const response = await api.delete(`/empresas/${id}`);
    return response.data;
  }

  /** Reexecuta a replicação dos cadastros de apoio a partir da empresa modelo. */
  async provisionar(id, opcoes = {}) {
    const response = await api.post(`/empresas/${id}/provisionar`, opcoes);
    return response.data;
  }

  /** Envia a logo (PNG/JPG/WEBP). Retorna { msg, logoUrl }. */
  async enviarLogo(id, arquivo) {
    const dados = new FormData();
    dados.append('logo', arquivo);

    const response = await api.post(`/empresas/${id}/logo`, dados, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  }

  async removerLogo(id) {
    const response = await api.delete(`/empresas/${id}/logo`);
    return response.data;
  }
}

const empresaService = new EmpresaService();
export default empresaService;
